module.exports = __webpack_public_path__ + "img/12.7ab5f64a.webp";